export default {
  header: require('./header_programmu.png'),
  alert: require('./alert.svg'),
  failed: require('./failed.svg'),
  no_badge: require('./no_badge.png'),
  no_cover: require('./no_cover.png'),
  account: require('./choose_account.png')
}
